;
var sprite = require("/tmp/build_133e1b25/node_modules/svg-sprite-loader/lib/web/global-sprite");;
var image = "<symbol viewBox=\"0 0 100 100\" id=\"Vitra_Save_2795354caa8fc60a505fc5727ec24384\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"> <g> <g> <polygon points=\"60.702,27.603 60.702,31.883 74.034,31.883 74.034,82.993 25.966,82.993 25.966,31.883 39.297,31.883 \r\n\t\t\t39.297,27.603 21.392,27.603 21.392,87.274 78.608,87.274 78.608,27.603 \t\t\"/> <polygon points=\"32.583,44.294 50,61.711 67.417,44.294 64.4,41.277 52.238,53.439 52.238,6.617 47.762,6.617 47.762,53.439 \r\n\t\t\t35.6,41.277 \t\t\"/> </g> </g> </symbol>";
module.exports = sprite.add(image, "Vitra_Save_2795354caa8fc60a505fc5727ec24384");


//////////////////
// WEBPACK FOOTER
// ./images/icons/Vitra_Save.svg
// module id = 1413
// module chunks = 0